import React, { useEffect, useState } from "react";
import PageWrapper from "../components/PageWrapper";
import Seo from "../components/Seo";
import AccessGate from "../components/AccessGate/AccessGate";
import { useAuth } from "../context/AuthContext";
import MentorDashboardLayout from "../sections/mentor-dashboard/MentorDashboardLayout";
import { canAccessMentor } from "../lib/permissions";

const TABS = ["overview", "juniors"];

const MentorDashboardPage = () => {
  const { role, tags, loading } = useAuth();
  const [tab, setTab] = useState("overview");
  const [focusJuniorId, setFocusJuniorId] = useState(null);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const sync = () => {
      const h = window.location.hash.replace(/^#/, "");
      if (TABS.includes(h)) setTab(h);
    };
    sync();
    // Deep-link: ?junior=<uid> opens that junior's drawer on the Juniors tab
    const juniorParam = new URLSearchParams(window.location.search).get("junior");
    if (juniorParam) {
      setFocusJuniorId(juniorParam);
      setTab("juniors");
      window.history.replaceState(null, "", `${window.location.pathname}#juniors`);
    }
    window.addEventListener("hashchange", sync);
    return () => window.removeEventListener("hashchange", sync);
  }, []);

  const setTabAndHash = (t) => {
    setTab(t);
    if (typeof window !== "undefined") {
      window.location.hash = t;
    }
  };

  if (loading) {
    return (
      <PageWrapper>
        <div style={{ padding: 96, color: "var(--nd-text-primary)" }}>loading…</div>
      </PageWrapper>
    );
  }

  if (!canAccessMentor(role, tags)) {
    return (
      <PageWrapper>
        <AccessGate
          pageName="Mentor Dashboard"
          purpose="Junior progress, streaks, at-risk signals, and path assignments in one place."
          requiredRole="admin"
          path="/mentor-dashboard"
        />
      </PageWrapper>
    );
  }

  return (
    <PageWrapper>
      <Seo title="Mentor Dashboard — Dioscuro" pathname="/mentor-dashboard" />
      <MentorDashboardLayout
        tab={tab}
        onTabChange={setTabAndHash}
        focusJuniorId={focusJuniorId}
        onFocusConsumed={() => setFocusJuniorId(null)}
      />
    </PageWrapper>
  );
};

export default MentorDashboardPage;
